module.exports = __webpack_public_path__ + "img/local_shipping.1933e35e.svg";